import {TrainingProductOriginDao} from '../../dao';
import {ProductOriginModel} from '../../models';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
const FUNCTION_CODE = 'UPDATE_CUSTOMER_CATEGORY_BY_ID';

export async function updateTrainingProductOrigin(
    userData: Record<string, string>,
    trainingProductOriginId: number,
    update: Record<string, any>
) {
    try {
        const result = await TrainingProductOriginDao.updateTrainingProductOrigin(userData.userToken, trainingProductOriginId, update);

        const resultParsed = ProductOriginModel.parseProductOrigin(result);

        return resultParsed;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
